import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import type {
  OnboardingWelcomeView,
  PmoFormView,
  SalesRepFormView,
  SubmitPmoFormInput,
  SubmitPmoFormResult,
  SubmitSalesRepFormInput,
  SubmitSalesRepFormResult,
  SubmitWelcomeFormInput,
  SubmitWelcomeFormResult,
} from '@catalyst-psa/shared';

import { publicApi } from '../project-portal/publicApi.js';

export function useOnboardingWelcomeView(token: string): UseQueryResult<OnboardingWelcomeView> {
  return useQuery({
    queryKey: ['welcome-portal', token],
    enabled: Boolean(token),
    retry: false,
    queryFn: () => publicApi.get<OnboardingWelcomeView>(`/public/onboarding/${token}`),
  });
}

export function useSubmitWelcomeForm(
  token: string,
): UseMutationResult<SubmitWelcomeFormResult, unknown, SubmitWelcomeFormInput> {
  return useMutation({
    mutationFn: (input: SubmitWelcomeFormInput) =>
      publicApi.post<SubmitWelcomeFormResult>(`/public/onboarding/${token}/submit`, input),
  });
}

export function useSalesRepFormView(token: string): UseQueryResult<SalesRepFormView> {
  return useQuery({
    queryKey: ['sales-rep-portal', token],
    enabled: Boolean(token),
    retry: false,
    queryFn: () => publicApi.get<SalesRepFormView>(`/public/onboarding/sales-rep/${token}`),
  });
}

export function useSubmitSalesRepForm(
  token: string,
): UseMutationResult<SubmitSalesRepFormResult, unknown, SubmitSalesRepFormInput> {
  return useMutation({
    mutationFn: (input: SubmitSalesRepFormInput) =>
      publicApi.post<SubmitSalesRepFormResult>(
        `/public/onboarding/sales-rep/${token}/submit`,
        input,
      ),
  });
}

export function usePmoFormView(token: string): UseQueryResult<PmoFormView> {
  return useQuery({
    queryKey: ['pmo-portal', token],
    enabled: Boolean(token),
    retry: false,
    queryFn: () => publicApi.get<PmoFormView>(`/public/onboarding/pmo/${token}`),
  });
}

export function useSubmitPmoForm(
  token: string,
): UseMutationResult<SubmitPmoFormResult, unknown, SubmitPmoFormInput> {
  return useMutation({
    mutationFn: (input: SubmitPmoFormInput) =>
      publicApi.post<SubmitPmoFormResult>(`/public/onboarding/pmo/${token}/submit`, input),
  });
}
